<template>
  <basicContainer>
    <el-form
      :inline="true"
      ref="downloadView"
      :model="uploadView.form"
      label-suffix=":"
    >
      <el-col :span="24" ref="uploadViewData" class="uploadFile">
        <input type="file" class="file" @change="uploading($event)" />
        <el-button type="success" class="file_btn"
        ><i class="el-icon-upload"></i
        ><span v-text="uploadViewData.label">上传文件</span></el-button>
      </el-col>
      <el-form-item class="item">
        <el-button type="info" @click="donwloadMb">导出模板</el-button>
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary" @click="dataBackfill">提交</el-button>
      </el-form-item>
    </el-form>
  </basicContainer>
</template>

<script>
import apiUpload from "@/dragComponents/mixins/apiUpload";

export default {
  mixins: [apiUpload],
  data() {
    return {
      form: {},
      file: "",
      uploadView: {
        show: false,
        form: {
          excelTemplateType: "",
          fileName: "人员档案"
        }
      },
      uploadViewData: {
        label: "上传文件"
      }
    };
  },
  methods: {
    uploading(event) {
      this.file = event.target.files[0];
      var windowURL = window.URL || window.webkitURL;
      this.file = event.target.files[0];
      this.src = windowURL.createObjectURL(event.target.files[0]);
      this.uploadViewData.label = this.file.name;
    },
    dataBackfill(form) {
      let formData = new window.FormData();
      formData.append("file", this.file);
      let config = {
        headers: {
          "Content-Type": "multipart/form-data"
        }
      };
      this.$http
        .post("/grdalc/importStaffInfo", formData, config)
        .then(res => {
          this.$message.success("导入成功!");
          let dataJson = {};
          let dataArr = [];
          let data = res.data;
          if (data != null) {
            Object.keys(data).forEach((key, index) => {
              let map = {};
              map.prop = key;
              map.value = data[key];
              dataArr.push(map);
            });
            dataJson.columnList = dataArr;
            parent.JsDataInteraction(dataJson);
          }
          parent.closeWindow();
        })
        .catch(error => {
          this.$message.error(error.msg);
        });
    },
    handleClose() {
      parent.closeWindow();
    },
    donwloadMb() {
		debugger
      this.$downloadFile.get("/common/document/download", {
        params: {
          fileName: "入职登记表.docx",
          fileUniqueCode: "1c065a520a8845aba5a14d09b0bbaca0",
          doDownload: true
        }
      }).then(r => {
        // throw r
      }).catch(e => {
        throw e;
      });
    },
    toUploadImg: function(event) {
      this.file = event.target.files[0]; // 获取文件
      var windowURL = window.URL || window.webkitURL;
      if (event.target.files[0]) {
        this.src = windowURL.createObjectURL(event.target.files[0]);
      }
      let formData = new window.FormData(); // vue 中使用 window.FormData(),否则会报 'FormData isn't definded'
      formData.append("file", this.file);
      let config = {
        headers: {
          "Content-Type": "multipart/form-data"
        }
      };
      formData.append("returnEntity", true);
      this.$http
        .post("/common/document/upload", formData, config)
        .then((res) => {
          this.$message.success("图片上传成功");
          this.$message({
            message: "图片上传成功",
            type: "success",
            duration: 2000
          });
        })
        .catch((error) => {
          this.$message.error(error.msg);
        });
    }
  }
};
</script>
<style lang="scss" scoped>
.file {
  z-index: 999;
  opacity: 0;
  position: absolute;
  left: 2px;
  width: 140px;
  cursor: pointer;
  height: 44px;
}

.file_btn {
  position: absolute;
  left: 2px;
  width: auto;
  z-index: 0;
}

.uploadFile {
  height: 80px;
}

.item {
  width: 100%;
  text-align: center;
}
</style>
